export const channelSavedFailed = {
  title: '操作できません。カスタマーセンターまでご連絡ください。',
};
